export type { AvatarProps, AvatarShape, AvatarSize } from '../../types/avatar';
export type { AvatarGroupItem, AvatarGroupProps } from '../../types/avatar-group';
export { Avatar } from './adapters/inbound/Avatar';
export { AvatarGroup } from './adapters/inbound/AvatarGroup';
export { resolveAvatarInitials } from './utils/resolveAvatarInitials';
